import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  SET_NAV_ACTION = '@navAction/SET',
}
export type NavButton = any;

export type NavButtonReducer = Reducer<NavButton, Action<ActionTypes>>;
